import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Tornado.svg",
  "use": "Tornado.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Tornado.svg\"><path d=\"M30,44c0,4.0474,5.963,6.444,5.963,13.1459A.8168.8168,0,0,1,35.17,58h0a.7175.7175,0,0,1-.752-.55C33.9385,52.9745,16,48.4058,16,39c0-5.5342,4-7.0194,4-10,0-4.1236-8-6.9167-8-13,0-5.5227,8.9544-10,20-10s20,4.4773,20,10C52,29.9661,30,33.609,30,44ZM32,9c-8.2843,0-15,2.6863-15,6s6.7155,6,15,6,15-2.6863,15-6S40.2844,9,32,9Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol